import { apiClient } from "api/ApiClient";

/**
 * 溶媒情報取得
 */
const getSolvent = async (id?: number) => {
    try {
        const response = await apiClient.get(`/solvent`, {
            id: id,
        });
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
    }
};

/**
 * 溶媒一覧取得(溶媒情報表示用)
 */
 const getSolventForInfo = async (id?: number) => {
    try {
        const response = await apiClient.get(`/solvent/solvent_info`, {
            id: id,
        });
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
    }
};

export const SolventApi = {
    getSolvent,
    getSolventForInfo,
};
